// extracted by mini-css-extract-plugin
export default {"container":"FavouriteButton_container__z02Hy"};